// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/pirep-filing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/pirep-filing/hazard-pirep-broadcast.js';
import g1 from '../lessons/meteorology/pirep-filing/pirep-filing.js';

mount([g0, g1]);
